// import React, { useEffect, useState } from "react";
// import "../Style/TestimonialData.css";
// import { useAuth } from "./UserContext.js";


// const TestimonialData = ({ options }) => {
//   const {
//     currentUser,
//     convertGoogleDriveLinkToIframe,
//     covertDriveLinkToImage,
//   } = useAuth();
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const nextTestimonial = () => {
//     setCurrentIndex(
//       (prevIndex) => (prevIndex + 1) % options?.testimonial.length
//     );
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex(
//       (prevIndex) =>
//         (prevIndex - 1 + options?.testimonial.length) %
//         options?.testimonial.length
//     );
//   };

//   const prevIndex =
//     (currentIndex - 1 + options?.testimonial.length) %
//     options?.testimonial.length;
//   const nextIndex = (currentIndex + 1) % options?.testimonial.length;

//   return options?.testimonial?.length === 0 ? (
//     <p
//       style={{
//         textAlign: "center",
//         fontSize: "30px",
//         fontWeight: "600",
//         color: "var(--primary-color",
//         marginTop: "30px",
//       }}
//     >
//       No Testimonials Available.
//     </p>
//   ) : (
//     <div className="testimonialCarouselContainer">
//       <button onClick={prevTestimonial} className="carouselButton left">
//         &#8592;
//       </button>

//       <div className="testimonialCard leftCard desktopOnly">
//         <div className="test-image-1">
//           <img
//             src={covertDriveLinkToImage(options?.testimonial[prevIndex]?.image)}
//           />
//         </div>
//         <p>{options?.testimonial[prevIndex]?.name}</p>
//         <h4>{options?.testimonial[prevIndex]?.subject}</h4>
//         <p>{options?.testimonial[prevIndex]?.description}</p>
//       </div>

//       <div className="testimonialCard middle">
//         <div className="test-image-1">
//           <img
//             src={covertDriveLinkToImage(
//               options?.testimonial[currentIndex]?.image
//             )}
//           />
//         </div>
//         <p>{options?.testimonial[currentIndex]?.name}</p>
//         <h4>{options?.testimonial[currentIndex]?.subject}</h4>
//         <p>{options?.testimonial[currentIndex]?.description}</p>
//       </div>

//       <div className="testimonialCard rightCard desktopOnly">
//         <div className="test-image-1">
//           <img
//             src={covertDriveLinkToImage(options?.testimonial[nextIndex]?.image)}
//           />
//         </div>
//         <p>{options?.testimonial[nextIndex]?.name}</p>
//         <h4>{options?.testimonial[nextIndex]?.subject}</h4>
//         <p>{options?.testimonial[nextIndex]?.description}</p>
//       </div>
//       <button onClick={nextTestimonial} className="carouselButton right">
//         &#8594;
//       </button>
//     </div>
//   );
// };

// export default TestimonialData;

import React, { useEffect, useState } from "react";
import "../Style/TestimonialData.css";
import { useAuth } from "./UserContext.js";

const TestimonialData = ({ options }) => {
  const {
    currentUser,
    convertGoogleDriveLinkToIframe,
    covertDriveLinkToImage,
  } = useAuth();
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = options?.testimonial || [];
  const total = testimonials.length;

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % total);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + total) % total);
  };

  const prevIndex = (currentIndex - 1 + total) % total;
  const nextIndex = (currentIndex + 1) % total;

  if (total === 0) {
    return (
      <p
        style={{
          textAlign: "center",
          fontSize: "30px",
          fontWeight: "600",
          color: "var(--primary-color",
          marginTop: "30px",
        }}
      >
        No Testimonials Available.
      </p>
    );
  }

  return (
    <div className="testimonialCarouselContainer">
      {total > 1 && (
        <button onClick={prevTestimonial} className="carouselButton left">
          &#8592;
        </button>
      )}

      {/* Only one testimonial */}
      {total === 1 && (
        <div className="testimonialCard single">
          <div className="test-image-1">
            <img
              src={covertDriveLinkToImage(testimonials[0]?.image)}
             alt={testimonials[0]?.name}
            />
          </div>
          <p>{testimonials[0]?.name}</p>
          <h4>{testimonials[0]?.subject}</h4>
          <p>{testimonials[0]?.description}</p>
        </div>
      )}

      {/* Multiple Testimonials - 3 or more */}
      {total > 2 && (
        <>
          <div className="testimonialCard leftCard desktopOnly">
            <div className="test-image-1">
              <img
                src={covertDriveLinkToImage(testimonials[prevIndex]?.image)}
              alt={testimonials[prevIndex]?.name}
              />
            </div>
            <p>{testimonials[prevIndex]?.name}</p>
            <h4>{testimonials[prevIndex]?.subject}</h4>
            <p>{testimonials[prevIndex]?.description}</p>
          </div>

          <div className="testimonialCard middle">
            <div className="test-image-1">
              <img
                src={covertDriveLinkToImage(testimonials[currentIndex]?.image)}
              alt={testimonials[currentIndex]?.name}
              />
            </div>
            <p>{testimonials[currentIndex]?.name}</p>
            <h4>{testimonials[currentIndex]?.subject}</h4>
            <p>{testimonials[currentIndex]?.description}</p>
          </div>

          <div className="testimonialCard rightCard desktopOnly">
            <div className="test-image-1">
              <img
                src={covertDriveLinkToImage(testimonials[nextIndex]?.image)}
                alt={testimonials[nextIndex]?.name}
              />
            </div>
            <p>{testimonials[nextIndex]?.name}</p>
            <h4>{testimonials[nextIndex]?.subject}</h4>
            <p>{testimonials[nextIndex]?.description}</p>
          </div>
        </>
      )}

      {/* Two Testimonials - Show only current */}
      {total === 2 && (
        <div className="testimonialCard middle">
          <div className="test-image-1">
            <img
              src={covertDriveLinkToImage(testimonials[currentIndex]?.image)}
              alt={testimonials[currentIndex]?.name}
            />
          </div>
          <p>{testimonials[currentIndex]?.name}</p>
          <h4>{testimonials[currentIndex]?.subject}</h4>
          <p>{testimonials[currentIndex]?.description}</p>
        </div>
      )}

      {total > 1 && (
        <button onClick={nextTestimonial} className="carouselButton right">
          &#8594;
        </button>
      )}
    </div>
  );
};

export default TestimonialData;

